var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDistanceToAnything = function SvgDistanceToAnything(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 21 21"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "distance_to_anything_svg__a",
    d: "M10 17.239V10H3.5a.5.5 0 0 1-.354-.146l-2-2a.5.5 0 0 1 0-.708l2-2A.5.5 0 0 1 3.5 5H10V1.5a.5.5 0 1 1 1 0V3h6.5a.5.5 0 0 1 .354.146l2 2a.5.5 0 0 1 0 .708l-2 2A.5.5 0 0 1 17.5 8H11v9.325c1.722.167 3.1.398 4.137.694a23.57 23.57 0 0 1 6.64 3.065.5.5 0 1 1-.554.832 22.57 22.57 0 0 0-6.36-2.935C12.586 18.33 8.456 18 2.5 18a.5.5 0 1 1 0-1c2.932 0 5.431.08 7.5.239zM10 9V6H3.707l-1.5 1.5 1.5 1.5H10zm1-5v3h6.293l1.5-1.5-1.5-1.5H11z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#distance_to_anything_svg__a",
    fill: "#4A4A4A",
    transform: "translate(-1 -1)"
  })));
};
export default SvgDistanceToAnything;